import config from '../../config';
import {createPreloadableLazyComponent} from '../../util/lazyImport';
import {type RouteData} from '../types';
import {
  ACCOUNT_SETTINGS_PATHS,
  ACCOUNT_SETTINGS_USAGE_PAGE_PATHS,
  PROJECT_SETTINGS_PATH,
  USER_SETTINGS_PATH,
} from './accountSettingPaths';

const IS_PRIVATE_ENV = config.ENVIRONMENT_IS_PRIVATE;

/**
 * Account-level routes (user settings, account settings, usage, storage explorer)
 */
export const ACCOUNT_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'UserSettings',
    },
    exact: true,
    isPrivateRoute: true,
    path: USER_SETTINGS_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../components/UserSettings/UserSettingsPage')
    ).Component,
  },
  {
    additionalProps: {
      allowIframes: false,
      skipTracking: true, // HomePageWithData handles tracking via HOME_NESTED_ROUTES
    },
    condition: !IS_PRIVATE_ENV,
    exact: true,
    isPrivateRoute: true,
    path: ACCOUNT_SETTINGS_PATHS,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/HomePage/HomePageWithData')
    ).Component,
  },
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'AccountSettingsUsagePage',
    },
    condition: !IS_PRIVATE_ENV,
    exact: true,
    isPrivateRoute: true,
    path: ACCOUNT_SETTINGS_USAGE_PAGE_PATHS,
    RouteComponent: createPreloadableLazyComponent(
      () =>
        import('../../pages/Billing/AccountSettings/ManageUsagePage/ManageUsagePage')
    ).Component,
  },
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'ProjectSettings',
    },
    exact: true,
    isPrivateRoute: true,
    path: PROJECT_SETTINGS_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/ProjectSettings/ProjectSettingsPage')
    ).Component,
  },
];
